export default [
  // Centers
  {
    path: "/TnSTFuEw",
    children: [
      {
        path: "/77YUr16a22aebbbdcd6db35628363hKRI",
        name: "baice25.centers",
        meta: {
          title: "BAICE 2025 centers",
          authRequired: true,
          acc: ["y47112"],
        },
        component: () =>
          import("@/views/baice/twf/center_management/index.vue"),
      },
      // view center
      {
        path: "/5z0w155b158c6e5cb07431af52fc9XZjs/:cn?",
        name: "baice25.center.view",
        meta: {
          title: "View BAICE 2025 center",
          authRequired: true,
          acc: ["y20377"],
        },
        component: () => import("@/views/baice/twf/center_management/view.vue"),
      },
      // assign center
      {
        path: "12978b24fb3e8462e6ec98f0/:cn?",
        name: "baice25.center.create",
        meta: {
          title: "Create BAICE 2025 center",
          authRequired: true,
          acc: ["y99931"],
        },
        component: () =>
          import("@/views/baice/twf/center_management/create.vue"),
      },
      //   {
      //     path: "hgnerugervbhoiuvervgye",
      //     name: "newCenters",
      //     meta: {
      //       title: "2025 baice NEW CENTERS",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/baice/twf/center_management/newCenters.vue"),
      //   },
      //   {
      //     path: "center_requests",
      //     name: "newCenterRequest",
      //     meta: {
      //       title: "2025 baice NEW CENTERS Requests",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/baice/twf/center_management/requests.vue"),
      //   },
      //   {
      //     path: "center_request/:cn?",
      //     name: "CenterRequestv",
      //     meta: {
      //       title: "2025 baice Requests Details",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/baice/twf/center_management/request.vue"),
      //   },
      //   {
      //     path: ":cn/edit_center",
      //     name: "editCenter",
      //     meta: {
      //       title: "EDIT CENTERS",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/baice/twf/center_management/edit-center.vue"),
      //   },
    ],
  },
];
